// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useHistory } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

import IconAlert from '@experimental-components/IconsComponents/Alert';

import theme from 'utils/theme';
import { MENU_ROUTES } from 'utils/menuMaker/constants';

import useStyles from './styles';

interface Props {
  t: (value: string) => void;
}

function BannerErrorPublishMenus({ t }: Props) {
  const classes = useStyles();

  const history = useHistory();
  const isSmallSize = useMediaQuery(theme.breakpoints.down('md'));

  const handleGoToPublish = () => {
    history.push(MENU_ROUTES.PUBLISH);
  };

  return (
    <Box className={classes.errorPublishMenu}>
      <Box className={classes.descriptionErrorPublish}>
        <IconAlert colorInherit="#FFF" size={20} />

        <Box component="p" lineHeight="14px" m={0}>
          {isSmallSize ? t('menuMaker:messages.isErrorPublishMenuShort') : t('menuMaker:messages.isErrorPublishMenu')}
        </Box>
      </Box>

      {history.location?.pathname !== MENU_ROUTES.PUBLISH ? (
        <Link
          className={classes.publishLink}
          color="secondary"
          component="button"
          onClick={handleGoToPublish}
          underline="none"
          variant="button"
        >
          {t('common:buttons.goToPublish')}
        </Link>
      ) : null}
    </Box>
  );
}

export default BannerErrorPublishMenus;
